import React, { useState, useEffect } from 'react';

function GLCodeModal({ isOpen, onClose, onSubmit, glCode, users }) {
  const [formData, setFormData] = useState({
    GL_Code: '',
    GL_Description: '',
    Current_Mid_Approver: '',
    Current_Second_Approver: '',
    Current_Sap_Approver: '',
    Previous_First_Approver: '',
    Previous_Second_Approver: '',
    Previous_Sap_Approver: ''
  });

  useEffect(() => {
    if (glCode && isOpen) {
      setFormData({
        GL_Code: glCode.gl_code || '',
        GL_Description: glCode.description || '',
        Current_Mid_Approver: glCode.mid || '',
        Current_Second_Approver: glCode.second || '',
        Current_Sap_Approver: glCode.approval || '',
        Previous_First_Approver: users[glCode.mid] || '',
        Previous_Second_Approver: users[glCode.second] || '',
        Previous_Sap_Approver: users[glCode.approval] || ''
      });
    }
  }, [glCode, users, isOpen]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  if (!isOpen) return null;

  // Convert users object to array for dropdowns
  const userOptions = Object.entries(users).map(([id, name]) => ({
    id,
    name
  }));

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
        <div className="mt-3">
          {/* Header */}
          <div className="flex justify-between items-center mb-4">
            <h4 className="text-lg font-medium text-gray-900">GL Details</h4>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <span className="sr-only">Close</span>
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* GL Code (readonly) */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                GL Code
              </label>
              <input
                type="text"
                name="GL_Code"
                value={formData.GL_Code}
                readOnly
                className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-500"
              />
            </div>

            {/* Description */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Description
              </label>
              <input
                type="text"
                name="GL_Description"
                value={formData.GL_Description}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>

            {/* First Approver */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                First Approver
              </label>
              <select
                name="Current_Mid_Approver"
                value={formData.Current_Mid_Approver}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                required
              >
                <option value="">Select First Approver</option>
                <option value="0">None</option>
                {userOptions.map(user => (
                  <option key={user.id} value={user.id}>
                    {user.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Second Approver */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Second Approver
              </label>
              <select
                name="Current_Second_Approver"
                value={formData.Current_Second_Approver}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                required
              >
                <option value="">Select Second Approver</option>
                <option value="0">None</option>
                {userOptions.map(user => (
                  <option key={user.id} value={user.id}>
                    {user.name}
                  </option>
                ))}
              </select>
            </div>

            {/* SAP Approver */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                SAP Approver
              </label>
              <select
                name="Current_Sap_Approver"
                value={formData.Current_Sap_Approver}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                required
              >
                <option value="">Select SAP Approver</option>
                <option value="0">None</option>
                {userOptions.map(user => (
                  <option key={user.id} value={user.id}>
                    {user.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Buttons */}
            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default GLCodeModal;
